<template>
  <div class="wrapper" >
  <!-- v-loading.fullscreen="loading" -->
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{$t('home')}}</router-link>
          <span>></span>
          <router-link
            :to="{path: '/search', query: {id: goodsInfo.goods_cat_id, name: goodsInfo.cat_name }}"
          >{{ goodsInfo.cat_name }}</router-link>
          <span>></span>
          <span>{{goodsInfo.name}}</span>
        </div>
      </div>
    </div>
    <div class="main bgw">
      <div class="shop-container" v-loading="loadingShow">
        <div class="t">
          <div class="tl">
            <div class="tl-tabs">
              <!-- <div class="prev" @click="!prevDisabled&&scrollPrev" :class="{disabled:prevDisabled}">
                <i class="icon iconfont iconprev"></i>
              </div>
              <div class="next" @click="!nextDisabled&&scrollNext" :class="{disabled:nextDisabled}">
                <i class="icon iconfont iconnext"></i>
              </div>-->
              <div class="img-list-box">
                <ul class="img-tabs" :style="{width:ulWidth,left:ulLeft+'px'}">
                  <li
                    v-for="(img,index) in productImgList"
                    :key="index"
                    @click="changeShowImg(img)"
                  >
                    <img v-lazy="img" alt :key="img" />
                  </li>
                </ul>
              </div>
            </div>

            <!-- <div class="tl-img-box">
              <vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify>
            </div> -->

            <div class="tl-img-box">
              <img class="play-acution" v-show="goodsInfo.video && goodsInfo.video.video_url" 
              src="@/assets/images/play-circle.png" alt="" @click="playYoutube">
              <div class="youtube-player" v-show="goodsInfo.video && goodsInfo.video.video_url && youtubeShow">

                 <video-player  style="width: 100%; height: 100%"  class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                ></video-player>


                <!-- <video  style="width: 100%; height: 100%" :src="goodsInfo.video.video_url"  ref="video" controls></video> -->
              </div>
              <vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify>

              <div class="img-no" v-if="goodsInfo.stock_status && goodsInfo.stock_status.status != 1">
                <img src="@/assets/images/nostock.png" />
              </div>
            </div>


          </div>
          <div class="tr">
            <div class="tr-title">{{goodsInfo.name}}</div>

            <div class="integral">
              <span v-if="goodsInfo.usable_price && goodsInfo.usable_price > 0">X币可抵￥{{goodsInfo.usable_price}}</span>
              <span  v-if="goodsInfo.reward_point && goodsInfo.reward_point > 0">购买赠送{{goodsInfo.reward_point}}X币</span>
            </div>


            <div class="tr-desc">{{goodsInfo.brief}}</div>
            <div class="tr-price tr-group">
              <div class="tr-title-left">{{$t('marketPrice')}}</div>
              <div class="tr-right" style="display: flex; align-items: center">
                <span class="old-price">
                  <del>￥{{goodsInfo.mktprice}}</del>
                </span>
              </div>
            </div>

            <div class="tr-price tr-group">
              <div class="tr-title-left">{{$t('promotion', {text: $t('price')})}}</div>
              <div class="tr-right">
                <span class="now-price">
                  <i>￥</i>
                  <span class="price-num">{{product.price}}</span>
                </span>
                <router-link v-if="!userToken" class="discounts-login" to="/login">
                  <span>{{$t('pleaseLogIn')}}</span>
                  ,{{$t('discountsTips')}}
                </router-link>
              </div>
            </div>
            <!-- <div class="tr-group underline" v-if="product && product.promotion_list&&product.promotion_list.length>0">
              <div class="tr-title-left"> {{$t('promotion', {text: ''})}} </div>
              <div class="tr-right">
                <span class="cx-item" v-for="(item,index) in product.promotion_list" :key="index">{{item.name}}</span>
              </div>
            </div>-->
            <template v-if="product && product.default_spes_desc">
              <div class="tr-group" v-for="(value,key,i) in product.default_spes_desc" :key="i">
                <div class="tr-title-left">{{key}}</div>
                <div class="tr-right">
                  <div
                    class="color"
                    v-for="(item, index) in value"
                    :key="index"
                    :class="{'active':item.cla.indexOf('is-selected') > -1, 'diable': item.disable }"
                    @click="changeSpes( key, item.name, item.disable)"
                  >
                    <a href="javascript:;">{{item.name}}</a>
                  </div>
                </div>
              </div>
            </template>

            <div class="tr-group">
              <div class="tr-title-left">{{$t('nums')}}</div>
              <div class="tr-right">
                <el-input-number
                  v-model="buyNum"
                  @change="handleChange"
                  :min="1"
                  :label="$t('buyNums')"
                  size="small"
                  :max="buyMax"
                ></el-input-number>
                <!-- 库存 件 -->
                <div class="kc">{{$t('inventory')}}{{product && product.stock || 0}}{{$t('piece')}}</div>
              </div>
            </div>
            <div class="tr-foot">
              <div
                class="btn buy-btn nostock"
                v-if="goodsInfo.stock_status && goodsInfo.stock_status.status != 1"
              >商品已售罄</div>
              <div class="tr-foot" v-else>
                <div
                  class="btn add-btn"
                  v-if="goodsInfo.marketable == 1 && !($store.state.config.account_switch == 1 && goodsInfo.account_id)"
                  @click="addToCart"
                  v-show="goodsInfo.is_nomal_virtual!=2"
                >{{$t('addToCart')}}</div>
                <div
                  class="btn buy-btn"
                  v-if="goodsInfo.marketable == 1"
                  @click="buyNow"
                >{{$t('buyNow')}}</div>

                <div class="btn sold-out" v-if="goodsInfo.marketable == 2">{{$t('soldOut')}}</div>
              </div>

              <div
                class="collete-btn"
                @click="changeFav"
                v-if="goodsInfo.marketable == 1"
                :title="isFav? $t('cancelCollection') : $t('addCollection')"
              >
                <i class="icon iconfont iconshoucang" v-if="isFav"></i>
                <i class="icon iconfont iconshoucang01" v-else></i>
                <div>{{isFav? $t('collected'): $t('collection')}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="product_related" v-if="relatedgoodsList.length > 0">
          <!-- 相关商品 -->
          <h2>
            <b>{{$t('relatedProducts')}}</b>
          </h2>
          <ul>
            <li v-for="item in relatedgoodsList" :key="item.id">
              <router-link :to="{name:'detail',params: {goodsId:item.id}}">
                <img class="img" :src="item.image_url" alt />
                <div class="related_name">
                  <!-- <router-link to="/"> -->
                  {{item.name}}
                  <!-- </router-link> -->
                </div>
              </router-link>
              <div class="add-wrap">
                <div class="price">￥{{item.price}}</div>
                <router-link class="add-btn" :to="{name:'detail',params: {goodsId:item.id}}">
                  <!-- 加入购物车  -->
                  {{$t('addToCart')}}
                </router-link>
              </div>
            </li>
          </ul>
        </div>
        <div class="b" style="position:relative">
          <div class="tabs">
            <div
              class="tab"
              v-for="(item,index) in tabTitleArr"
              :key="index"
              @click="returnTo(item.id)"
              :class="{active:tabIndex==index}"
            >{{item.name}}</div>
          </div>
          <div style="overflow: hidden;">
            <div class="leaderboard">
              <div class="title">{{$t('rankingList')}}</div>
              <div class="board">
                <div
                  class="item"
                  v-for="(item,index) in saleRanking"
                  :key="index"
                  @click="toDetails(item.id)"
                >
                  <!-- <div class="number">{{index+1}}</div> -->
                  <div class="img">
                    <img :src="item.image" alt />
                  </div>
                  <div class="info">
                    <div class="name">{{item.name}}</div>
                    <div class="price">{{$t('currencySymbol')}}{{item.price}}</div>
                    <div class="sold">
                      {{$t('beenSold')}}
                      <span class="num">{{item.buy_count}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="shop-info-wrap" style="width:75%;float:left">
              <div id="detail">
                <div v-if="goodsParams" class="params-wrap">
                  <h3>{{$t('goods', {text: $t('params')})}}</h3>
                  <div
                    v-for="(item,index) in goodsParams"
                    :key="index"
                    class="params-content"
                  >{{item.name}}：{{item.value}}</div>
                </div>
                <div class="shop-info-item" v-show="tabIndex==0" v-html="goodsInfo.intro"></div>
              </div>

              <div class="shop-info-item" id="comment">
                <h3>{{$t('evaluation')}}</h3>
                <div v-if="goodsComments.count==0">
                  <div class="no-comment">{{$t('noEvaluation')}}</div>
                </div>
                <div v-for="(item,index) in goodsComments.list" :key="index" class="comment" v-else>
                  <div class="user">
                    <div class="user-head">
                      <img :src="item.user.avatar" alt />
                    </div>
                    <span class="user-name">{{item.user.nickname}}</span>
                  </div>
                  <div class="detail">
                    <div class="score">
                      <el-rate v-model="item.score" disabled></el-rate>
                    </div>
                    <div class="content">{{item.content}}</div>
                    <div v-if="item.images_url" class="img-list">
                      <div
                        v-for="(img,i) in item.images_url"
                        :key="i"
                        class="img-li"
                        @click="changeBigImg(img,i,index,item)"
                        :class="{'active':img==item.currentImg}"
                      >
                        <img :src="img" alt />
                      </div>
                    </div>
                    <transition name="img-zoom">
                      <div
                        v-show="item.showBigImg"
                        class="big-img"
                        :class="{'hidden':!item.showBigImg}"
                      >
                        <img :src="item.currentImg" alt />
                      </div>
                    </transition>

                    <div class="time">
                      <span class="addon" v-if="item.addon">{{item.addon}}</span>
                      {{item.ctime}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in">
      <div class="scrollTop" v-show="toTopShow" @click="scrollToTop">
        <i class="icon iconfont iconfanhuidingbu"></i>
        <p>{{$t('top')}}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import vueMagnify from "@/components/vue-magnify/index.vue";
import { timeToDate } from "@/utils";
import { mapActions } from "vuex";
export default {
  name: "ProductDetail",
  components: { vueMagnify },
  props: {},
  data() {
    return {

      playerOptions : {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          // type: "application/x-mpegURL",
          // video/mp4
          src: ''//url地址          
          // src: "" //url地址
        }],
        poster: "", //你的封面地址
        // notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      youtubeShow: false,
      toTopShow: false,
      buyNum: 1,
      tabTitleArr: [
        {
          id: "detail",
          name: this.$t("detail")
        },
        {
          id: "comment",
          name: this.$t("comment")
        }
      ],
      tabIndex: 0,
      goodsId: "",
      imgList: [],
      ulLeft: 0,
      isEnd: false,
      goodsInfo: {}, //商品详情
      product: {}, // 规格详情
      isFav: false, //收藏
      goodsParams: null, //商品参数信息
      goodsComments: {
        count: 0,
        page: 1,
        limit: 15,
        list: null
      }, // 商品评论信息, //商品评论信息
      currentImg: "", //列表选中图片
      selectCommentImg: "", //评论选中图片
      selectCommentImgIndex: null, //评论选中图片
      selectCommentIndex: null, //评论选中图片
      loadingShow: false,
      saleRanking: [], //销量排行榜
      userToken: "",
      relatedgoodsList: [], // 相关商品
      loading: false,
      specData: {},
      minBuyNum: 1,
      getAjax: 0
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == "detail") {
        let goodsId = this.$route.params.goodsId;
        if (goodsId) {
          this.goodsId = goodsId;
          this.getAllInfo();
          this.relatedgoods();
        }
      }
      if (this.$route) {
        this.buyNum = 1;
      }
    }
  },
  computed: {
    ulWidth() {
      if (this.goodsInfo.album) {
        return this.goodsInfo.album.length * 62 + "px";
      }
      return 0 + "px";
    },
    prevDisabled() {
      return this.ulLeft == 0;
    },
    nextDisabled() {
      if (this.goodsInfo.album) {
        return this.goodsInfo.album.length <= 5 || this.isEnd;
      }
      return false;
    },
    buyMax() {
      return (this.product && this.product.stock) || 1;
    },
    productImgList() {
      return this.goodsInfo.album;
    }
  },
  methods: {
    ...mapActions(["getCartNumsAction"]),
    handleChange(value) {},
    scrollPrev() {
      this.ulLeft = 0;
    },

    playYoutube() {
      this.youtubeShow = true
      // setTimeout(() => {
        this.$refs.videoPlayer.player.play()

      // }, 500)
    },


    // 相关商品
    relatedgoods() {
      this.$api
        .relatedgoods({
          page: 1,
          limit: 12,
          order: "sort asc",
          goods_id: this.goodsId
        })
        .then(res => {
          if (res.status) {
            this.relatedgoodsList = res.data;
          }
        });
    },
    scrollNext() {
      let num = this.productImgList.length - 5;
      let left = 54 * num + 24;
      this.ulLeft = -left;
      this.isEnd = true;
    },
    addToCart(val) {

      // 多规格 提醒
			if(this.product.default_spes_desc && (Object.keys(this.specData).length != Object.keys(this.product.default_spes_desc).length)) {
        this.$message({
          message: this.$t('pleaseSelectSpecification'), // "请选择规格",
          type: 'error'
        })
				return
			}
      let data = {};
      data = {
        product_id: this.product.id,
        nums: this.buyNum
      };

      // if(val) {
      //   data = {
      //     product_id: val.product_ids,
      //     nums: 1,
      //   }
      // } else {
      //   data = {
      //     product_id: this.product.id,
      //     nums: this.buyNum,
      //   }
      // }

      this.$api.addCart(data).then(res => {
        if (res.status) {
          // this.$message({
          //   message: res.msg,
          //   type: 'success',
          // })
          this.getCartNums();
          this.$router.push({
            path: "/buySuccess",
            query: { goodsName: this.goodsInfo.name }
          });
          this.specData = {}
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    buyNow() {

      // 多规格 提醒
			if(this.product.default_spes_desc && (Object.keys(this.specData).length != Object.keys(this.product.default_spes_desc).length)) {
        this.$message({
          message: this.$t('pleaseSelectSpecification'), // "请选择规格",
          type: 'error'
        })
				return
			}

      
      let data = {
        product_id: this.product.id,
        nums: this.buyNum,
        type: 2 // 区分加入购物车和购买
      };
      this.$api.addCart(data).then(res => {
        if (res.status) {
          let cartIds = res.data;
          this.$router.push({
            name: "order",
            query: { cart_ids: JSON.stringify(cartIds) }
          });
          this.specData = {}
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data);
        }
      });
    },
    //切换评论图片大图
    changeBigImg(img, i, index, item) {
      if (img == item["currentImg"]) {
        this.$set(item, "showBigImg", false);
        this.$set(item, "currentImg", "");
      } else {
        this.$set(item, "showBigImg", true);
        this.$set(item, "currentImg", img);
      }
      // if (this.selectCommentIndex == index) {
      // } else {
      //   this.selectCommentImg = img;
      //   this.selectCommentImgIndex = i;
      // }

      this.selectCommentIndex = index;
    },
    //切换显示图片
    changeShowImg(img) {
      this.currentImg = img;
      this.youtubeShow = false
       this.$refs.videoPlayer.player.pause()
    },
    returnTo(id) {
      // document.getElementById(id).scrollIntoView({behavior: "smooth"})
      document.getElementById(id).scrollIntoView();
    },
    //获取商品参数
    getGoodsParams() {
      let data = { id: this.goodsId };
      this.$api.goodsParams(data).then(res => {
        if (res.status) {
          this.goodsParams = res.data;
        }
      });
    },
    getGoodsComments() {
      let data = {
        page: this.goodsComments.page,
        limit: this.goodsComments.limit,
        goods_id: this.goodsId
      };
      this.$api.goodsComment(data).then(res => {
        if (res.status) {
          let _list = res.data.list;
          _list.forEach(item => {
            item.ctime = timeToDate(item.ctime);
            this.$set(item, "showBigImg", false);
            this.$set(item, "currentImg", "");
          });
          this.goodsComments.list = _list;
          this.goodsComments.count = res.data.count;
        }
      });
    },
    //商品详情
    getGoodsDetail() {
      this.loading = true;
      let data = {
        id: this.goodsId
      };
      let userToken = this.$storage.get("userToken");
      if (userToken) {
        data["token"] = userToken;
      }
      this.loadingShow = true;
      this.$api.goodsDetail(data).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status) {
          this.loadingShow = false;
          let info = res.data;
          this.goodsInfo = info;
          // this.product = res.data.product;
          if (res.data.product && res.data.product.default_spes_desc) {
              res.data.product.default_spes_desc = this.sortSpecs(res.data.product.default_spes_desc, res.data.new_spec);
          }
          this.product = this.spesClassHandle(res.data.product);
          this.isFav = info.isfav === "true" ? true : false;

          if(info.video && info.video.video_url) {
              if(info.video.video_url.indexOf('.m3u8') > -1) {
                this.playerOptions.sources[0].type = 'application/x-mpegURL'
              } else {
                this.playerOptions.sources[0].type = 'video/mp4'
              }
			  
			  this.playerOptions.sources[0].src= info.video.video_url
			  this.playerOptions.poster = res.data.cover
          }
                
          this.currentImg = this.goodsInfo.album[0] || "";
          if (this.$storage.get("userToken")) {
            this.goodsBrowsing();
          }
        }
      });
    },
    spesClassHandle(products, flag) {
      // 判断是否是多规格 (是否有默认规格)
      if (products.hasOwnProperty('default_spes_desc')) {
          let spes = products.default_spes_desc;
          for (let key in spes) {
              for (let i in spes[key]) {
                if(flag) {
                  this.$set(spes[key][i], 'cla', 'pop-m-item' );
                } else {
                  this.$set(spes[key][i], 'cla', 'pop-m-item not-selected' );
                }
              }
          }
          products.default_spes_desc = spes;
      }
      return products;
    },
    goodsBrowsing() {
      let data = {
        goods_id: this.goodsInfo.id
      };
      this.$api.addGoodsBrowsing(data).then();
    },
    sortSpecs(dataObj, newSpecStr) {
      if (newSpecStr) {
        try {
          let newSpecArr = JSON.parse(newSpecStr);
          newSpecArr.sort((a, b) => (parseInt(a.sort) || 0) - (parseInt(b.sort) || 0));
          let sortedObj = {};
          newSpecArr.forEach(item => {
            if (dataObj.hasOwnProperty(item.name)) {
              sortedObj[item.name] = dataObj[item.name];
            }
          });
          for (let k in dataObj) {
            if (!sortedObj.hasOwnProperty(k)) {
              sortedObj[k] = dataObj[k];
            }
          }
          return sortedObj;
        } catch (e) {
          console.error("解析 newSpec 失败", e);
        }
      }
      return dataObj;
    },
    // 1大 2小 对象是否包含
    isInclude(array1,array2){
      let key = Object.keys(array2)[0]
      let value = array2[key]
      for(let i of array1) {
        if(Object.keys(i)[0] == key && value == i[ Object.keys(i)[0]]) {
        return true
        }
      }
      return false
    },
    //切换商品规格
    changeSpes(id, item, disable) {
       if(disable) {
        return
      }

      if(this.getAjax >= 2) {
        return
      }

			const _this = this
      if(id) {
        // console.log(obj, this.product.spec_product);
        let index = id;
        let key = item;
        // 没有选中 切换为选中状态
        if(this.product.default_spes_desc[index][key].cla.indexOf('not-selected') > -1) {
          // 当前组 全部恢复默认
          for(let i in this.product.default_spes_desc[index]) {
            this.$set(this.product.default_spes_desc[index][i], 'cla', 'pop-m-item not-selected');
          }
          // 存储当前选中的规格
          this.$set(this.specData, index, key)
          // 改变当前为选中状态
          this.$set(this.product.default_spes_desc[index][key], 'cla', 'pop-m-item is-selected');
          
          // 只要点击了带有图片的规格且为选中状态，马上切换弹出层商品图
          if (this.product && this.product.default_spes_desc && this.product.default_spes_desc[index] && this.product.default_spes_desc[index][key]) {
            let specObj = this.product.default_spes_desc[index][key];
            if (specObj.cla.indexOf('is-selected') > -1 && specObj.image_id && specObj.image_id.length > 0) {
              this.changeShowImg(specObj.image_id[0].src);
            }
          }
        } else {
          // 如果选中了 取消
          delete this.specData[index]
          this.$set(this.product.default_spes_desc[index][key], 'cla', 'pop-m-item not-selected');
          // 一个规格取消 直接return
          if(this.product.default_spes_desc && Object.keys(this.product.default_spes_desc).length == 1 ) {
            return
          }
        }
      }
			
      console.log(1)
			
			let str = ''
			for(let z in this.specData) {
				str += `${z}:${this.specData[z]},`
			}
			if(str.length) {
				str = str.substr(0, str.length - 1)
			}
			this.$api.getproductbysku({
				id: _this.product.goods_id,
				spec: str
			}).then(res => {
				if(res.status) {
          if(res.data.length > 0) {
            this.getAjax = 0
					let prod = res.data
					for(let k in this.product.default_spes_desc) { 
						for(let spec_value of  Object.keys(this.product.default_spes_desc[k])) {
							// console.log('this.product.default_spes_desc[k][spec_value].disable', this.product.default_spes_desc[k][spec_value].disable);
							if( str.length == 0) {
								this.$set(this.product.default_spes_desc[k][spec_value], 'disable', false)
							} else {
								let arr = 0
								
								let data = []
								let concatArr = []
								let obj = {}
								obj[k] = spec_value
								
								for(let i in prod) {
									if(prod[i].spes_desc.indexOf(`${k}:${spec_value}`) < 0 || !this.isInclude(prod[i].spec, obj) ) {
										arr++
									} 
								}
								// 一个规格
								if(Object.keys(this.product.default_spes_desc).length == 1) {
									if(prod[0].spes_desc.indexOf(`${k}:${spec_value}`) > -1) {
										this.$set(this.product.default_spes_desc[k][spec_value], 'disable', false)
									} else {
										// 如果点击的当前规格组 什么也不做
										if(Object.keys(this.specData).join(',').indexOf(k) > -1 ) {
											
										} else {
											this.$set(this.product.default_spes_desc[k][spec_value], 'disable', true)
										}
									}
								} else {
									// 多规格
									if(arr == prod.length ) {
										// 如果点击的当前规格组 什么也不做
										if(Object.keys(this.specData).join(',').indexOf(k) > -1 ) {
										} else {
											this.$set(this.product.default_spes_desc[k][spec_value], 'disable', true)
										}
									} else {
										this.$set(this.product.default_spes_desc[k][spec_value], 'disable', false)
									}
								}
							}
						}
					}
					
					if(Object.keys(this.specData).length == Object.keys(this.product.default_spes_desc).length) {
						let data = {
						    id: prod[0].id
						};
						// return
            
						let userToken = this.$storage.get("userToken");
						if (userToken) {
						    data['token'] = userToken;
						}
						this.$api.getProductInfo(data).then(result => {
						    if (result.status == true) {
						        // 切换规格判断可购买数量
						        this.buyNum = result.data.stock > this.minBuyNum ? this.minBuyNum : result.data.stock;
								let copy = JSON.parse(JSON.stringify(this.product.default_spes_desc)) 
						        this.product = result.data
								this.$set(this.product, 'default_spes_desc', copy)
						    }
						});
					}
        } else {

          //  this.$message({
          //   message: "暂无库存, 请重新选择",
          //   icon: 'none'
          // })

           // 如果选中了 取消
          // delete this.specData[id]
          // this.$set(this.product.default_spes_desc[id][item], 'cla', 'pop-m-item not-selected');

          if(Object.keys(this.product.default_spes_desc).length > 0 && id) {
            let strArr = []
            for(let i in this.product.default_spes_desc) {
              strArr.push(i)
            }

            const findcurrentIndex = strArr.findIndex(item => item == id)

            strArr = strArr.splice(findcurrentIndex + 1, strArr.length - 1)

            console.log(strArr)

            for(let k in this.specData) {
              for(let j of strArr) {
                if(j == k) {
                  delete this.specData[k]
                  for(let z in this.product.default_spes_desc[k]) {
                    this.$set(this.product.default_spes_desc[k][z], 'cla', 'pop-m-item not-selected');
                  }
                }
              }
            }
            this.changeSpes()
          }
        }
				}
			})
    },
    //切换收藏
    changeFav() {
      let data = {
        goods_id: this.goodsInfo.id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.isFav = !this.isFav;
        }
      });
    },
    getAllInfo() {
      this.getGoodsDetail();
      this.getGoodsParams();
      this.getGoodsComments();
    },
    handleScroll() {
      this.scrollTop = this.scrollTop =
        window.pageYOffset || document.body.scrollTop;
      if (this.scrollTop > 500) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // 获取销量排行榜
    getSalesRanking() {
      this.$api.getSalesRanking({}).then(res => {
        if (res.status) {
          this.saleRanking = res.data;
          console.log(this.saleRanking);
        }
      });
    },
    toDetails(id) {
      this.$router.push({
        name: "detail",
        params: { goodsId: id }
      });
    }
  },
  destroyed() {
    this.specData = {}
  },
  created() {},
  mounted() {
    this.specData = {}
    this.userToken = localStorage.getItem("userToken");
    let goodsId = this.$route.params.goodsId;
    this.goodsId = goodsId;
    this.getAllInfo();
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll);
    });
    // 获取销量排行榜
    this.getSalesRanking();
    this.relatedgoods();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.product_related {
  width: 1226px;
  border: 1px solid #eeeeee;
  margin-top: 20px;
  h2 {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: normal;
    color: #4c4c4c;
    b {
      display: block;
      font-weight: normal;
      padding-left: 15px;
      color: #4c4c4c;
      height: 40px;
      font-size: 16px;
    }
  }
  ul {
    width: 1198px;
    overflow: hidden;
    margin: 10px 0px;
    li {
      width: 160px;
      overflow: hidden;
      float: left;
      text-align: center;
      margin-left: 26px;
      margin-right: 10px;
      margin-bottom: 10px;
      .img {
        width: 160px;
        height: 160px;
      }
      .related_name {
        height: 36px;
        line-height: 18px;
        overflow: hidden;
        margin-top: 10px;
        font-size: 12px;
        &:hover {
          color: #09f;
        }
      }
      .add-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #e7442f;
        .price {
          font-weight: bold;
        }
        .add-btn {
          font-size: 12px;
          color: #e7442f;
          border: 1px solid currentColor;
          padding: 4px 8px;
          cursor: pointer;
        }
      }
    }
  }
}
.img-zoom-enter-active,
.img-zoom-leave-active {
  width: 100%;
  transition: all 0.2s linear;
}
.img-zoom-enter,
.img-zoom-leave-to {
  width: 0;
  opacity: 0;
}
.scrollTop {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: $theme-color;
  text-align: center;
  color: #fff;
  z-index: 999;
  cursor: pointer;
  .icon {
    display: block;
    margin-top: 12px;
    margin-bottom: 5px;
  }
  p {
    font-size: 12px;
  }
}
.comment {
  display: flex;
  border-bottom: 1px solid $border;
  padding: 15px 0;
  .user {
    display: inline-flex;
    .user-head {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
      overflow: hidden;
      img {
        display: block;
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
    }
    .user-name {
      display: inline-block;
      color: #757575;
      font-size: 12px;
      width: 75px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .detail {
    flex: 1;
    .content {
      padding: 10px 0;
    }
    .img-list {
      margin: 10px 0;
      display: inline-flex;
      .img-li {
        width: 52px;
        height: 52px;
        margin-right: 10px;
        margin-bottom: 5px;
        border: 1px solid $border;
        padding: 2px;
        &.active {
          padding: 1px;
          border: 2px solid $theme-color;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .big-img {
      max-width: 300px;
      border: 1px solid $border;
      padding: 2px;
      &.hidden {
        border: none;
        padding: 0;
      }
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }
    .time {
      color: #999;
      font-size: 12px;
      margin-top: 10px;
      .addon {
        margin-right: 20px;
      }
    }
  }
}

.wrapper {
  .main {
    padding-top: 14px;
    .t {
      display: flex;
      padding-bottom: 30px;
      .tl {
        margin-right: 20px;
        display: flex;
        .tl-img-box {
          width: 350px;
          height: 350px;
          border: 1px solid $border;
          margin-bottom: 20px;
          position: relative;
          .play-acution {
            position: absolute;
            left: 10px;
            bottom:10px;
            width: 40px;
            height: 40px;
            z-index: 9;
          }
          .youtube-player {
            position: absolute;
            left: 0;
            top: 0;
            width: 350px;
            height: 350px;
            z-index: 9;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .img-no {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(255,255,255,.7);
            display: flex;
            align-items: center;
            justify-content: center;
            >img {
              width: 195px;
              height: 195px;
            }
          }
        }
        .tl-tabs {
          height: 340px;
          position: relative;
          margin-right: 10px;
          .img-list-box {
            width: 60px;
            height: 340px;
            // margin: 0 auto;
            position: relative;
            overflow: hidden;
            padding-bottom: 4px;
            ul {
              position: absolute;
              left: 0;
              top: 0;
              height: 54px;
              transition: left 0.15s linear;
              li {
                width: 54px;
                height: 54px;
                // float: left;
                margin: 0 4px;
                border: 1px solid $border;
                padding: 1px;
                box-sizing: border-box;
                &:hover {
                  border: 2px solid $theme-color;
                  padding: 0;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
				margin-bottom: 3px;
              }
            }
          }
          .prev {
            position: absolute;
            left: -5px;
            top: 50%;
            width: 26px;
            height: 26px;
            margin-top: -16px;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              .icon {
                color: $border;
              }
            }
            .icon {
              font-size: 26px;
              color: #757575;
            }
          }
          .next {
            position: absolute;
            right: -5px;
            top: 50%;
            width: 26px;
            height: 26px;
            margin-top: -16px;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              .icon {
                color: $border;
              }
            }
            .icon {
              font-size: 26px;
              color: #757575;
            }
          }
        }
      }
      .tr {
        flex: 1;
        position: relative;
        .tr-title {
          font-weight: 700;
          color: #666;
          padding-top: 10px;
          line-height: 28px;
          font-size: 18px;
          margin-bottom: 5px;
        }
        .tr-desc {
          font-size: 14px;
          margin-bottom: 20px;
        }
        .tr-group {
          margin-bottom: 15px;
          position: relative;
          display: flex;
          &.underline {
            padding-bottom: 10px;
            border-bottom: 1px solid $border;
          }
          .tr-title-left {
            color: #838383;
            font-size: 12px;
            display: inline-block;
            min-width: 60px;
            padding-right: 10px;
            height: 32px;
            line-height: 32px;
          }
          .tr-right {
            display: inline-block;
            flex: 1;
            .discounts-login {
              font-size: 12px;
              cursor: pointer;
              span {
                color: #e7442f;
              }
            }
            .now-price {
              color: $theme-color;
              text-align: left;
              margin-right: 20px;
              i {
                font-size: 16px;
              }
              .price-num {
                font-size: 22px;
              }
            }
            .old-price {
              color: #666;
              font-size: 12px;
            }
            .cx-item {
              padding: 2px 4px;
              background: $theme-color;
              color: #fff;
              margin-right: 10px;
              font-size: 12px;
              height: 24px;
              line-height: 24px;
            }
            .color,
            .size {
              font-size: 12px;
              border: 1px solid #b8b7bd;
              margin-right: 8px;
              display: inline-block;
              height: 28px;
              line-height: 28px;
              margin-bottom: 12px;
              &.active {
                border-color: $theme-color;
                background: $theme-color;
                color: #fff;
              }
              a {
                display: block;
                padding: 0 10px;
              }
              &:hover {
                border: 1px solid $theme-color;
              }
            }
            .weight {
              font-size: 12px;
            }
            .kc {
              color: #878787;
              display: inline-block;
              font-size: 12px;
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  bottom: 0;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.nostock {
      background-color: #B0B0B0;
      border: none;
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
.b {
  padding: 20px 0;
  border-top: 1px solid $border;
  .tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    .tab {
      font-size: 16px;
      padding: 0px 15px;
      cursor: pointer;
      &:not(:last-of-type) {
        border-right: 1px solid $border;
      }
      &.active,
      &:hover {
        color: $theme-color;
      }
    }
  }
  .shop-info-wrap {
    border: 1px solid $border;
    padding: 20px;
    .params-wrap {
      padding: 15px 0;
      border-bottom: 1px solid $border;
      margin-bottom: 20px;
      h3 {
        margin-bottom: 10px;
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding-left: 20px;
      }
      .params-content {
        padding-left: 20px;
        color: #757575;
        font-size: 12px;
        margin: 10px 0;
      }
    }
    #comment {
      padding: 15px 0;
      h3 {
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding-left: 20px;
      }
      .no-comment {
        padding-left: 20px;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
.leaderboard {
  float: left;
  width: 21%;
  margin-right: 7px;
  .title {
    background-color: #eee;
    line-height: 40px;
    padding: 0 5px;
  }
  .board {
    border: 1px solid #dee2e9;
    background-color: #fff;
    .item:last-child {
      border: none;
    }
    .item {
      display: flex;
      justify-content: flex-start;
      border-bottom: 1px solid #dee2e9;
      padding: 10px;
      cursor: pointer;
      .number {
        background-color: #333;
        color: #fff;
        width: 20px;
        text-align: center;
        height: 20px;
        line-height: 20px;
      }
      .img {
        width: 150px;
        // height: 150px;
        object-fit: cover;
        // border: 1px solid #dee2e9;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        width: 63%;
        margin-left: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .name {
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #666;
          font-size: 12px;
          line-height: 18px;
        }
        .price {
          color: #ff7159;
        }
        .sold {
          color: #666;
          font-size: 12px;
          .num {
            color: #ff7159;
          }
        }
      }
    }
  }
}

.color.diable {
  color: #ccc;
  border: 1px solid #ccc;
  cursor: not-allowed !important;
  a {
    cursor: not-allowed !important;
  }
  &:hover {
    border: 1px solid #ccc !important;
  }
}


.integral {
  margin-top:10px;
  margin-bottom: 14px;
		span {
			color: #ff4444;
			background: rgba(243, 235,227, .5);
			padding: 4px 20px;
			border-radius: 4px;
			font-size: 12px;
			margin-right: 10px;
		}
	}


 
</style>

<style lang="scss">
.preview-box {
  img {
    height: 350px;
    object-fit: cover;
  }
}

 .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3 {
    height: 100% !important;
  }

.shop-info-item {
  video {
    width: 100%;
    height: auto;
  }
}
</style>